define(function (require) {
    'use strict';

    var Marionette = require('marionette');
    var Backbone = require('backbone');
    var Page = require('views/_page');
    var AppConfig = require('config/application');

    return Page.extend({
        className: 'content inner-content',
        getTemplate: function() {
            return this.options.menu.html_big || ''
        },
        ui: {
            startBtn: '.js-start-use-page',
            modalBtn: '.js-arcticmodal'
        },
        events: {
            'click @ui.startBtn': 'startUsing',
            'click @ui.modalBtn': 'openModal'
        },
        initialize: function() {
            $('body').css('overflow-y', 'auto');
        },
        openModal: function(event) {
            var that = this;
            var template = $(event.currentTarget).data('template');

            if (that.$('#' + template).length) {
                that.$('#' + template).arcticmodal().data('arcticmodal').body.find('.js-start-use-page').click(function(event) {
                    event.preventDefault();
                    Backbone.ajax({
                        type: 'POST',
                        url: AppConfig.host + '/system/menu_html_big_button_clicked',
                        data: JSON.stringify({status: 1, menu_id: that.options.menu.id}),
                        success: function() {
                            that.options.menu.button_clicked = 1;
                            Backbone.history.loadUrl(Backbone.history.fragment);
                        }
                    })
                })
            }
        },
        startUsing: function(event) {
            var that = this;

            event.preventDefault();
            Backbone.ajax({
                type: 'POST',
                url: AppConfig.host + '/system/menu_html_big_button_clicked',
                data: JSON.stringify({status: 1, menu_id: this.options.menu.id}),
                success: function() {
                    that.options.menu.button_clicked = 1;
                    Backbone.history.loadUrl(Backbone.history.fragment);
                }
            })
        }
    })
});
